<template>
  <v-container fluid>
    <v-dialog v-model="formDialogStatus" max-width="600px">
      <formDialog
        :dialogStatus.sync="formDialogStatus"
        :editedData="editedItem"
        :indexEdited.sync="editedIndex"
        @saveText="setDatasForInsert($event)"
      ></formDialog>
    </v-dialog>
    <v-dialog v-model="deleteDialogStatus" max-width="600px">
      <deleteDialog
        v-on:changeTitle="updateTitleData($event)"
        v-on:changeStat="closeDelDialog($event)"
      ></deleteDialog>
    </v-dialog>
    <div>
      <v-container fluid style="width: 100%">
        <v-layout wrap>
          <v-flex xs2 sm2 md2>
            <navDrawer />
          </v-flex>
          <v-flex xs10 sm10 md10>
            <v-card color="white">
              <v-layout row>
                <!-- {{getTitle}} -->
                <v-card flat>
                  <v-card-text class="title"><b>Education Type List </b></v-card-text>
                </v-card>
                <v-divider class="my-2" vertical></v-divider>

                <v-spacer />
                <v-card flat>
                  <v-card-actions>
                    <v-spacer />

                    <v-btn color="primary" dark @click="newItem"
                      >Create New Education Type  </v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-layout>
            </v-card>
            <v-data-table
              :headers="headers"
              :items="getEduTypeItem"
              hide-default-footer
              disable-pagination
              class="elevation-1"
            >
              <template v-slot:item.actions="{ item }">
                <v-icon
                  fab
                  small
                  color="primary"
                  class="mr-2"
                  @click="editItem(item)"
                >
                  mdi-pencil
                </v-icon>
                <v-icon small color="red" @click="deleteDialogOpen(item)">
                  mdi-delete
                </v-icon>
              </template>
              <template v-slot:no-data>
                <v-btn color="primary" > Reset </v-btn>
              </template>
            </v-data-table>
            <div>
              <v-col cols="12" sm="12">
                <v-row>
                  <v-col cols="12" sm="4">
                    <v-autocomplete
                      v-model="pagination.pageSize"
                      :items="pagination.pageSizes"
                      label="Items per Page"
                      @change="checker(1)"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="8">
                    <v-pagination
                      v-model="pagination.currentPage"
                      :length="pagination.totalPage"
                      total-visible="7"
                      next-icon="mdi-menu-right"
                      prev-icon="mdi-menu-left"
                      @input="checker(0)"
                    ></v-pagination>
                  </v-col>
                </v-row>
              </v-col>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
  </v-container>
</template>

<script>
import formDialog from "@/components/education/educationTpeForm.vue";
import deleteDialog from "@/components/utils/deleteDialog.vue";
import navDrawer from "@/layouts/navDrawer.vue";
import paginationMixin from "../../mixins/pagination";

export default {
  components: {
    formDialog,
    navDrawer,
    deleteDialog
  },
  data() {
    return {
      editedItem:{},
      editedIndex: -1,
      loading: false,
      title : "tiiii",
      dialog: false,
      formDialogStatus: false,
      deleteDialogStatus:false,
      deleteId:{},
      currentItem: {},
      snackBar: {
          control: false,
          timeout: 2000,
          multiline: true,
          text: {
              code: null,
              status: '',
              message: '',
          },
      },

      headers: [
        // {
        //   text: "SL.",
        //   align: "left",
        //   sortable: true,
        //   value: "id",
        // },
        { text: "Name", value: "title", sortable: false },
       
        
        { text: "Actions", value: "actions", sortable: false },
      ],
    };
  },
  async created() {
    // await this.$store.dispatch("callEducationTypeData");
    await this.checker();
    this.pagination.totalPage = Math.ceil(this.pagination.totalItems/this.pagination.pageSize);
    this.snackBar.text = await this.$store.getters.getResponseMessage;
  },
  computed: {
    getEduTypeItem() {
      return this.$store.getters.getEduTypeItem;
    },
    getLoggedInStatus() {
      return this.$store.getters.getLoggedIn;
    },
    getTitle(){
      return this.title;
    }
  },
  watch: {
    getTitle(val){
    
      if(val == "confirmed"){
        this.deleteItem();
      }
    },
    pagination() {
      // this.getDataFromApi();
    },
  },
  mixins: [
    paginationMixin
  ],
  methods: {
    dialogOpen() {
      this.formDialogStatus = true;
    },
     closeDelDialog(deleteDialogStatus){
        this.deleteDialogStatus = false;
      },
     updateTitleData(title){
        this.title = title;
      },
    newItem() {
      
      this.dialogOpen();
    },
     editItem(item) {
      this.editedIndex = this.getEduTypeItem.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogOpen();
    },
     deleteDialogOpen(item){
      this.deleteId = item.id;
      this.deleteDialogStatus = true;
     },
     async deleteItem() {
      // const id = item.id;
      let self = this;
        
        await this.$store
        .dispatch("deleteEduTypeItem", this.deleteId)
        .then(function(data) {
       
          try {
            self.deleteDialogStatus = false;
            self.$store.dispatch("callEducationTypeData");
            
          } catch (ex) {
           //  console.log(ex);
          }
        })
        .catch(function(error) {
         //  console.log(error);
          
        });
      this.snackBar.text = await this.$store.getters.getResponseMessage;
      this.pagination.totalItems = await this.$store.getters.getDataCount;
      this.snackBar.control = true;
    },
    async caller(){
      return this.$store.dispatch("callEducationTypeData", {
        page: this.pagination.currentPage,
        size: this.pagination.pageSize,
      });
    }
  },
};
</script>
<style>
.mycustomExpansionPanel .v-expansion-panel__header {
  border: 1px solid blue !important;
}
</style>
